import { iconBgVariants } from '@/components/ui/IconBg'
import { IconV2CorrectOutline } from '@icons/IconV2CorrectOutline'
import { IconV2ArrowLeftOutline } from '@icons/IconV2ArrowLeftOutline'
import { IconV2UploadOutline } from '@icons/IconV2UploadOutline'
import type { VariantProps } from 'class-variance-authority'
import { IconV2ClockOutline } from '@icons/IconV2ClockOutline'

type IconBgVariant = NonNullable<VariantProps<typeof iconBgVariants>['variant']>

export const stateMap = {
  Accepted: {
    name: 'Accepted',
    icon: IconV2CorrectOutline,
    variant: 'success',
    color: 'text-statusgreen-500',
    backgroundColor: 'bg-statusgreen-50',
    borderColor: 'border border-statusgreen-500',
  },
  Uploaded: {
    name: 'Uploaded',
    icon: IconV2UploadOutline,
    variant: 'warning',
    color: 'text-statusyellow-500',
    backgroundColor: 'bg-statusyellow-50',
    borderColor: 'border border-statusyellow-500',
  },
  Returned: {
    name: 'Returned',
    icon: IconV2ArrowLeftOutline,
    variant: 'error',
    color: 'text-statusred-500',
    backgroundColor: 'bg-statusred-50',
    borderColor: 'border border-statusred-500',
  },
  None: {
    name: 'None',
    icon: IconV2ClockOutline,
    variant: 'info',
    color: 'text-muted',
    backgroundColor: 'bg-offwhite',
    borderColor: 'border border-muted',
  },
} satisfies Record<string, { variant: IconBgVariant } & Record<string, unknown>>

export const stateOptions = Object.values(stateMap).map((state) => state.name)

export const stateOptionsWithAll = ['All', ...stateOptions]
